import { setRating } from "../Api";

export default {
    state: {
        isMovieRatingSanded: false,
        timeOut: 3000,
        timer: null
    },
    mutations: {
        updateMovieRatingSended(state) {
            state.isMovieRatingSanded = true;

            if (state.timer) {
                clearTimeout(state.timer);
            }

            state.timer = setTimeout(() => {
                state.isMovieRatingSanded = false;
                state.timeOut = 3000;
                state.timer = null;
            }, state.timeOut);
        }
    },
    actions: {
        setMovieRating({ commit }, payload) {
            commit("updateMovieRatingSended");
            setRating(payload.vid, payload.rating);
        }
    },
    getters: {
        getIsMovieRatingSended(state) {
            return state.isMovieRatingSanded;
        }
    }
};
